import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//  Services
import { AuthenticationService } from '../../services/authentication.service';
import { AbstractService } from '../../services/abstract.service';

//  Libraries
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'dashboard-component',
  templateUrl: './dashboard.component.html',
  providers: []
})

export class DashboardComponent implements OnInit {

  activeRoute: String;
  session: any = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private abstractService: AbstractService) {

  }

  ngOnInit() {
    this.session = this.authService.retrieveSession();
    this.activeRoute = this.router.url;

    this.authService.Session$.subscribe(session => {      
      this.session = session;
      this.activeRoute = this.router.url;

      if (!session) {
        this.router.navigate(['']);
      }
    });
  }

  updateNav(current: String) {
    this.activeRoute = current;
  }

  signOut() {
    this.authService.clearSession();
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts